import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
/**
 * Israeli ID validator – דורש בדיוק 9 ספרות (כולל אפסים מובילים),
 * וללא השלמה אוטומטית. מוודא גם ספרת ביקורת.
 */
export function israeliIdValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = (control.value ?? '').toString().trim();

    // ריק: השאירו ל-Validators.required לטפל אם השדה חובה
    if (raw === '') return null;

    // חייב בדיוק 9 ספרות (כולל אפסים מובילים)
    if (!/^\d{9}$/.test(raw)) {
      return { israeliId: { reason: 'length' } };
    }

    // דחיית 000000000
    if (raw === '000000000') {
      return { israeliId: { reason: 'checksum' } };
    }

    // בדיקת ספרת ביקורת (כפל מתחלף 1/2; אם >9 מחסירים 9)
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      const d = Number(raw[i]);
      let step = d * ((i % 2) + 1);
      if (step > 9) step -= 9;
      sum += step;
    }

    const valid = sum % 10 === 0;
    return valid ? null : { israeliId: { reason: 'checksum' } };
  };
}